/**
 * Utility function to help with exhaustive checks in TypeScript.
 */
export const notReachable = (value: never): never => {
  throw new Error(`Not reachable: ${value}`);
};
